/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestEventsLookup } from '../../models/harvest-events-lookup';

export interface DeleteHarvestEventsLookup$Params {
  harvestEventsLookupId: number;
}

export function deleteHarvestEventsLookup(http: HttpClient, rootUrl: string, params: DeleteHarvestEventsLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestEventsLookup>> {
  const rb = new RequestBuilder(rootUrl, deleteHarvestEventsLookup.PATH, 'delete');
  if (params) {
    rb.path('harvestEventsLookupId', params.harvestEventsLookupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestEventsLookup>;
    })
  );
}

deleteHarvestEventsLookup.PATH = '/api/harvesteventslookup/{harvestEventsLookupId}';
